import type { Reducer } from "@reduxjs/toolkit";
import { getType } from "typesafe-actions";

import * as SessionActions from "./actions";
import type { ISessionState, SessionAction } from "./types";

const initialState: ISessionState = {
  isSyncing: false,
  hasError: false,
  sessionData: null! // this must be null initial, else breaks language selector currently
};

const sessionReducer: Reducer<ISessionState, SessionAction> = (state = initialState, action: SessionAction) => {
  switch (action.type) {
    case getType(SessionActions.fetchSession):
      return { ...state, isSyncing: true };

    case getType(SessionActions.updateDebitor):
      return { ...state, isSyncing: true };

    case getType(SessionActions.updateLanguage):
      return { ...state, isSyncing: true };

    case getType(SessionActions.sessionSyncSuccess):
      return { ...state, isSyncing: false, sessionData: action.payload };

    case getType(SessionActions.sessionSyncFail):
      return { ...state, isSyncing: false, hasError: true };

    default:
      return state;
  }
};

export default sessionReducer;
